/*
* 路由器模块
* */

import Vue from 'vue'
import VueRouter from 'vue-router'
import envJS from '../common/js/env'

import Payment from '../pages/Payment/Payment'
import AutPayment from '../pages/Payment/AutPayment'
import Profile from '../pages/Profile/Profile'
import CardNumPayment from '../pages/CardNumPayment/CardNumPayment'
import AddressPayment from '../pages/AddressPayment/AddressPayment'
import HouseholdPayment from '../pages/HouseholdPayment/HouseholdPayment'
import FreedomPayment from '../pages/FreedomPayment/FreedomPayment'
import PayDetail from '../pages/PayDetail/PayDetail'
import Order from '../pages/Order/Order'
import OrderDetail from '../pages/Order/OrderDetail'
import payResult from '../pages/Order/payResult'
import AddressManage from '../pages/AddressManage/AddressManage'
import AddAddress from '../pages/AddressManage/addAddress'
import Settings from '../pages/Settings/Settings'
import UpdateName from '../pages/Settings/UpdateName'
import UpdatePassword from '../pages/Settings/UpdatePassword'
import UpdatePhone from '../pages/Settings/UpdatePhone'
import Login from '../pages/Login/Login'
import Register from '../pages/Login/Register'
import WxAuth from '../pages/Wxauth/Wxauth'
import Auth from '../pages/Wxauth/Auth'
import ReportRepair from '../pages/heatReportRepair/ReportRepair'
import AddressCheck from '../pages/heatReportRepair/AddressCheck'
import RepairOrder from '../pages/repairOrder/repairOrder'
import RepairOrderDetail from '../pages/repairOrder/repairOrderDetail'
import ErrorPage from '../pages/ErrorPage/ErrorPage'
import Stop from '../pages/Stop/Stop'
import Detail from '../pages/Stop/detail'
import choujiang from '../pages/choujiang/choujiang'
import coupon from '../pages/choujiang/list'
import invoicing from '../pages/invoicing/invoicing'
import invoicingList from '../pages/invoicing/invoicingList'
import invoicingPreview from '../pages/invoicing/invoicingPreview'
import evaluate from '../pages/evaluate/evaluate'
import evaluateList from '../pages/evaluate/list'
// import updateTest from '../pages/updateTest/updateTest'
Vue.use(VueRouter)

export default new VueRouter({
  mode:'history',
  routes: [
    {
      name:"payment",
      path:'/payment/:companyId',
      component:Payment,
      meta: {
        title: envJS.baseTitle,
        showFooter:true,
        requireAuth:true
      }
    },
    {
      name:"autpayment",
      path:'/autpayment/:companyId',
      component:AutPayment,
      meta: {
        title: '缴费',
        showFooter:true,
        requireAuth:true
      }
    },
    {
      name:"profile",
      path:'/profile/:companyId',
      component:Profile,
      meta: {
        title: '我的',
        showFooter:true,
        requireAuth:true
      }
    },
    {
      name:"cardnumpayment",
      path:'/cardnumpayment/:companyId',
      component:CardNumPayment,
      meta: {
        title: '热力卡号缴费',
        requireAuth:true
      }
    },
    {
      name:"addresspayment",
      path:'/addresspayment/:companyId',
      component:AddressPayment,
      meta: {
        title: '房屋地址缴费',
        requireAuth:true
      }
    },
    {
      name:"householdpayment",
      path:'/householdpayment/:companyId',
      component:HouseholdPayment,
      meta: {
        title: '分户计量缴费',
        requireAuth:true
      }
    },
    {
      name:"freedompayment",
      path:'/freedompayment/:companyId',
      component:FreedomPayment,
      meta: {
        title: '自助信息填写缴费',
        requireAuth:true
      }
    },
    {
      name:"paydetail",
      path:'/paydetail/:companyId',
      component:PayDetail,
      meta: {
        title: '缴费明细',
        requireAuth:true
      }
    },
    {
      name:"order",
      path:'/order/:companyId',
      component:Order,
      meta: {
        title: '缴费订单',
        requireAuth:true
      }
    },
    {
      name:"orderdetail",
      path:'/orderdetail/:companyId',
      component:OrderDetail,
      meta: {
        title: '订单详情',
        requireAuth:true
      }
    },
    {
      name:"payresult",
      path:'/payresult/:companyId',
      component:payResult,
      meta: {
        title: '付款结果',
        requireAuth:true
      }
    },
    {
      name:"addressmanage",
      path:'/addressmanage/:companyId',
      component:AddressManage,
      meta: {
        title: '地址管理',
        requireAuth:true
      }
    },
    {
      name:"addaddress",
      path:'/addaddress/:companyId',
      component:AddAddress,
      meta: {
        title: '新增地址',
        requireAuth:true
      }
    },
    {
      name:"settings",
      path:'/settings/:companyId',
      component:Settings,
      meta: {
        title: '设置',
        requireAuth:true
      }
    },
    {
      name:"updatename",
      path:'/updatename/:companyId',
      component:UpdateName,
      meta: {
        title: '修改昵称',
        requireAuth:true
      }
    },
    {
      name:"updatepassword",
      path:'/updatepassword/:companyId',
      component:UpdatePassword,
      meta: {
        title: '修改密码',
        requireAuth:true
      }
    },
    {
      name:"updatephone",
      path:'/updatephone/:companyId',
      component:UpdatePhone,
      meta: {
        title: '修改手机号',
        requireAuth:true
      }
    },
    {
      name:"login",
      path:'/login/:companyId',
      component:Login,
      meta: {
        title: '登录',
        requireAuth:true
      }
    },
    {
      name:"register",
      path:'/register/:companyId',
      component:Register,
      meta: {
        title: '注册',
        requireAuth:true
      }
    },
    {
      name:'wxauth',
      path:'/wxauth/:companyId',
      component:WxAuth,
      meta: {
        title: envJS.baseTitle,
      }
    },
    {
      name:'auth',
      path:'/auth/:companyId',
      component:Auth,
      meta: {
        requireAuth:true,
        title: envJS.baseTitle,
      }
    },
    {
      name:'errorpage',
      path:'/errorpage',
      component:ErrorPage,
      meta: {
        requireAuth:true,
        title: envJS.baseTitle,
      }
    },
    {
      name:"reportrepair",
      path:'/reportrepair/:companyId',
      component:ReportRepair,
      meta: {
        title: '供热报修',
        showFooter:true,
        requireAuth:true
      }
    },
    {
      name:"addresscheck",
      path:'/addresscheck/:companyId',
      component:AddressCheck,
      meta: {
        title: '供热报修',
        showFooter:false,
        requireAuth:true
      }
    },
    {
      name:"repairorder",
      path:'/repairorder/:companyId',
      component:RepairOrder,
      meta: {
        title: '供热报修订单',
        showFooter:false,
        requireAuth:true
      }
    },
    {
      name:"repairorderdetail",
      path:'/repairorderdetail/:companyId',
      component:RepairOrderDetail,
      meta: {
        title: '报修订单详情',
        showFooter:false,
        requireAuth:true
      }
    },
	{
	  name:"stop",
	  path:'/stop/:companyId',
	  component:Stop,
	  meta: {
	    title: '供热状态变更',
	    showFooter:false,
	    requireAuth:true
	  }
	},
	{
	  name:"detail",
	  path:'/detail/:companyId',
	  component:Detail,
	  meta: {
	    title: '供热状态变更详情',
	    showFooter:false,
	    requireAuth:true
	  }
	},
	{
	  name:"choujiang",
	  path:'/choujiang/:companyId',
	  component:choujiang,
	  meta: {
	    title: '抽奖',
	    showFooter:false,
	    requireAuth:true
	  }
	},
	{
	  name:"coupon",
	  path:'/coupon/:companyId',
	  component:coupon,
	  meta: {
	    title: '优惠券管理',
	    showFooter:false,
	    requireAuth:true
	  }
	},
	{
	  name:"invoicing",
	  path:'/invoicing/:companyId',
	  component:invoicing,
	  meta: {
	    title: '申请开票',
	    showFooter:false,
	    requireAuth:true
	  }
	},
	{
	  name:"invoicingList",
	  path:'/invoicingList/:companyId',
	  component:invoicingList,
	  meta: {
	    title: '我的发票',
	    showFooter:false,
	    requireAuth:true
	  }
	},
	{
	  name:"invoicingPreview",
	  path:'/invoicingPreview/:companyId',
	  component:invoicingPreview,
	  meta: {
	    title: '预览发票',
	    showFooter:false,
	    requireAuth:true
	  }
	},
	{
	  name:"evaluate",
	  path:'/evaluate/:companyId',
	  component:evaluate,
	  meta: {
	    title: '在线评价',
	    showFooter:false,
	    requireAuth:true
	  }
	},
	{
	  name:"evaluateList",
	  path:'/evaluateList/:companyId',
	  component:evaluateList,
	  meta: {
	    title: '在线评价',
	    showFooter:false,
	    requireAuth:true
	  }
	},
	
	// {
	//   name:"updateTest",
	//   path:'/updateTest/:companyId',
	//   component:updateTest,
	//   meta: {
	//     title: '数据更新查询',
	//     showFooter:false,
	//     requireAuth:true
	//   }
	// },
  ]
})







// WEBPACK FOOTER //
// ./src/router/index.js